import locale from '../../../utils/locale';

const yesNoData = [{display: locale('yes'), value: 'Y'}, {display: locale('no'), value: 'N'}];

const personalBelongingsOptionsData = [
    {display: locale('yes'), value: 'Y'},
    {display: locale('need_more_time'), value: 'need_more_time'},
    {display: locale('donot_intend_to'), value: 'N'}
]
const keysOptionsData = [
    {display: locale('yes'), value: 'Y', helpText: locale('helpTextKey')},
    {display: locale('need_more_time'), value: 'need_more_time'},
    {display: locale('do_not_have_keys'), value: 'NA'}
]
const followUpOptionsData = [
    {display: locale('hours_2'), value: '2'},
    {display: locale('hours_4'), value: '4'},
    {display: locale('hours_8'), value: '8'},
    {display: locale('I am not ready'), value: 'not_ready'}
]
const readyForPickUpOptionsData = [
    {display: locale('yes'), value: 'Y'},
    // {display: locale('pickup_on'), value: 'pick_up_on'},
    {display: locale('follow_up_in'), value: 'follow_up'}
]

const ownerPresentOptionsData = [
    {display: locale('Yes, I do not need to be present'), value: 'Yes, I do not need to be present', helpText: locale('keysTextKey')},
    {display: locale('No, please meet me at the pickup address'), value: 'No, please meet me at the pickup address', helpText: locale('keysTextKey')},
]

const defaultPickupTimeOptionsData = [
    {display: locale('8:00AM - 12:00PM'), value: '8:00AM - 12:00PM', helpText: locale('timeTextKey')},
    {display: locale('12:00PM - 4:00PM'), value: '12:00PM - 4:00PM', helpText: locale('timeTextKey')},
    {display: locale('Either works for me'), value: 'NA', helpText: locale('timeTextKey')},
]

const afterTenPickupTimeOptionsData = [
    {display: locale('12:00PM - 4:00PM'), value: '12:00PM - 4:00PM', helpText: locale('timeTextKey')}
]

const doesWheelsRollData = [
    {display: locale('tires_inflated'), value: locale('tires_inflated')},
    {display: locale('vehicle_engine_starts'), value: 'Vehicle engine starts'},
    {display: locale('vehicle_can_drive_safely'), value: 'Vehicle can drive safely under its own power'},
    {display: locale('none'), value: 'None'}
]

export default [
    {
        name: 'removedPersonalBelongings',
        label: locale('personalBelongings'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: personalBelongingsOptionsData
    },
    {
        name: 'hasKeys',
        label: locale('hasKeys'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: keysOptionsData
    },
    {
        name: 'policyHolder',
        label: locale('policyHolder'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: yesNoData
    },
    {
        name: 'vehicleIsBlocked',
        label: locale('isAnythingBlocking'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: yesNoData
    },
    {
        name: 'doesWheelsRoll',
        label: locale('doesWheelsRoll'),
        type: 'checkbox',
        readable: true,
        editable: true,
        required: true,
        dataSource: doesWheelsRollData
    },
    {
        name: 'readyForPickup',
        label: locale('Is your vehicle ready for Copart to pickup?'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: readyForPickUpOptionsData
    },
    {
        name: 'pickUpOn',
        label: locale('Pick up on'),
        type: 'date',
        value: "10/17/2019",
        readable: true,
        editable: true,
        required: true,
    },
    {
        name: 'followUp',
        label: locale('Please follow up with me in'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        dataSource: followUpOptionsData,
        tab: true
    },
    {
        name: 'comments',
        label: locale('Enter Comments'),
        type: 'text',
        readable: true,
        editable: true,
        required: true,
        multiline: true,
        maxLength: 150
    },
    {
        name: 'pickupTime',
        label: locale('pickupTime'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        multiline: true,
        dataSource: defaultPickupTimeOptionsData
    },
    {
        name: 'pickupTime1',
        label: locale('pickupTime'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        multiline: true,
        dataSource: afterTenPickupTimeOptionsData
    },
    {
        name: 'ownerPresent',
        label: locale('ownerPresent'),
        type: 'radio',
        readable: true,
        editable: true,
        required: true,
        multiline: true,
        dataSource: yesNoData
    }
]



// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/pickupDetails.js